//#region imports
import { Component, OnInit } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { DetailsService } from 'src/app/services/details.service';
import { TranslateService } from '@ngx-translate/core';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Globals } from 'src/app/services/globals';
import { formatDate } from '@angular/common';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { DocumentService } from 'src/app/services/document.service';
import { SectionService } from 'src/app/services/section.service';
//#endregion

@Component({
  selector: 'app-details-question8',
  templateUrl: './details-question8.component.html',
  styleUrls: ['./details-question8.component.css']
})
export class DetailsQuestion8Component implements OnInit {
  //#region variables
  choices = [];
  firstCheck: boolean;
  secondCheck: boolean;
  thirdCheck: boolean;
  //#endregion

  //#region methods
  constructor(
    private detailsService: DetailsService, private guaranteeService: GuaranteeService,
    private globals: Globals, private notification: NotificationService,private sectionService: SectionService,
    private translate: TranslateService, private characteristicService: CharacteristicService,
    private documentService: DocumentService) {
    this.characteristicService.setShowPrevious(true);
  }

  ngOnInit() {
    this.sectionService.setCurrentPage('P22-2');
    this.globals.trackPageActivity += ';' + 'P22-2';
    const sectionKey = AppConstants.SectionConstants.Section2Point2;
    const questionChoices = this.detailsService.getDetailsData(sectionKey, 'G13');
    this.setAnswers();
    for (const choice of questionChoices) {
      this.choices.push(choice);
    }
  }

  setAnswers() {
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    this.globals.quesWarning = false;
    const answers = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G13').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Indoor_Features_Block').Answers;
    if (answers != null) {
      this.firstCheck = answers.findIndex(obj => obj.Answerkey === 'Apartment_Nature_Flooring_Question') >= 0 ? true : false;
      this.secondCheck = answers.findIndex(obj => obj.Answerkey === 'Apartment_Heating_Question') >= 0 ? true : false;
      this.thirdCheck = answers.findIndex(obj => obj.Answerkey === 'Apartment_Cellars_Question') >= 0 ? true : false;
    }
  }

  onApartmentNatureFlooringChange($event) {
    if ($event.target.checked) {
      this.documentService.setHouseOrApartmentNatureFlooring(true);
    } else {
      this.documentService.setHouseOrApartmentNatureFlooring(false);
    }
  }

  selectedAnswer(choice) {
    this.guaranteeService.setInitialPricingData(null);
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    this.mapAnswer(choice);
  }

  mapAnswer(selectedChoice) {
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    const translatedChoice = this.translate.instant(selectedChoice);
    const today = new Date();
    for (const choice of this.choices[0]) {
      if (choice.ChoiceKey === selectedChoice) {
        const AnswerObject = {
          ChoiceId: choice.ChoiceId, Answerkey: choice.ChoiceKey, AnswerText: translatedChoice,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        };
        const answers = data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G13').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Indoor_Features_Block').Answers;
        if (answers == null) {
          data.Sections.find(obj => obj.SectionKey === 'S2.2').
            QuestionGroup.find(obj => obj.GroupKey === 'G13').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Indoor_Features_Block').Answers = [AnswerObject];
        } else if (answers.findIndex(obj => obj.ChoiceId === AnswerObject.ChoiceId) < 0) {
          data.Sections.find(obj => obj.SectionKey === 'S2.2').
            QuestionGroup.find(obj => obj.GroupKey === 'G13').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Indoor_Features_Block').Answers.push(AnswerObject);
        } else {
          data.Sections.find(obj => obj.SectionKey === 'S2.2').
            QuestionGroup.find(obj => obj.GroupKey === 'G13').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Indoor_Features_Block').
            Answers.splice(answers.findIndex(obj => obj.ChoiceId === AnswerObject.ChoiceId), 1);
        }
      }
    }
    sessionStorage.setItem('jsonData', JSON.stringify(data));
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
